import currencies from "../../constants/CurrencyData";
import { useTranslation } from "react-i18next";
import { SelectField } from "../../components/ui";

const currencyOpts = Object.values(currencies).map((item) => ({
  label: item.name,
  value: item.code,
}));

const CurrencyPicker = (props: any) => {
  const { onChange, currencyCode, isDisabled } = props;
  const { t } = useTranslation();

  const selected = currencyOpts.find((item) => item.value === currencyCode) || null;
  return (
    <SelectField
      label={t("Currency")}
      placeholder={t("Select currency") as string}
      options={currencyOpts}
      value={selected as any}
      onChange={(opt: any) => {
        if (opt && typeof onChange === "function") {
          onChange(opt.value);
        }
      }}
      isClearable={false}
      isDisabled={isDisabled}
    />
  );
};

export default CurrencyPicker;
